import { Col, Progress, Row, Select } from "antd";
import React, { FC, useEffect, useState } from "react";
import "./analyticsCard.scss";
import { ArrowLeftOutlined, DownOutlined } from "@ant-design/icons";
import ScoreIcon from "../../../../../../../assets/icons/reward.svg";
import AccuracyIcon from "../../../../../../../assets/icons/dart.svg";
import SpeedIcon from "../../../../../../../assets/icons/sketch.svg";
import DurationIcon from "../../../../../../../assets/icons/sand-clock.svg";
import { secondsFormatConverter } from "../../../../../../../shared/utils/secondsFormatConverter";

interface AnalyticsCardProps {
  showPaper: boolean;
}
const AnalyticsCard: FC<AnalyticsCardProps> = ({ showPaper = false }) => {
  const [classAnalytics, setClassAnalytics] = useState<any>();
  const fetchClass = () => {};

  useEffect(() => {
    fetchClass();
  }, []);

  return (
    <div className="analytics__card">
      <Row className="mlp-3">
        <Col span={3}>
          <div className="analytics-rank__container">
            <Select
              className="course__dropdown"
              placeholder="Select course"
              options={[
                { value: "Class 8", label: "Class 8" },
                { value: "JEE", label: "JEE" },
              ]}
            />
            <div className="analytics__rank">Rank 04</div>
          </div>
        </Col>
        <Col span={3}>
          <div className="analytics__metric">
            <img src={ScoreIcon} />
            <div>
              <p className="analytics-measure__value">
                {classAnalytics?.score ?? 0} <span>%</span>
              </p>
              <p className="analytics__measure">Score</p>
            </div>
          </div>
        </Col>
        <Col span={3}>
          <div className="analytics__metric">
            <img src={AccuracyIcon} />
            <div>
              <p className="analytics-measure__value">
                {classAnalytics?.accuracy ?? 0} <span>%</span>
              </p>
              <p className="analytics__measure">Accuracy</p>
            </div>
          </div>
        </Col>
        <Col span={3}>
          <div className="analytics__metric">
            <img src={SpeedIcon} />
            <div>
              <p className="analytics-measure__value">
                {classAnalytics?.averageTimePerQuestion?.toFixed() ?? 0}{" "}
                <span>sec/ques</span>
              </p>
              <p className="analytics__measure">Speed</p>
            </div>
          </div>
        </Col>
        <Col span={3}>
          <div className="analytics__metric">
            <img src={DurationIcon} />
            <div>
              <p className="analytics-measure__value">
                {secondsFormatConverter(
                  classAnalytics?.exerciseAttemptDuration
                )}
              </p>
              <p className="analytics__measure">Duration spent</p>
            </div>
          </div>
        </Col>
        <Col span={6}>
          <div className="progress__metric">
            <div className="progress__container">
              <p className="progress__title">Content learnt</p>
              <div className="progress__wrapper">
                <p className="progress__score">
                  23<span>/89</span>
                </p>
                <Progress percent={20} />
              </div>
            </div>
            <div className="progress__container">
              <p className="progress__title">Exercise attempted</p>
              <div className="progress__wrapper">
                <p className="progress__score">
                  23<span>/89</span>
                </p>
                <Progress percent={20} />
              </div>
            </div>
          </div>
        </Col>
        {/* <Col span={3}>
          <img src={AccuracyIcon} />
          <p className="analytics-measure__value">
            40<span>/90</span>
          </p>
          <p className="analytics__measure">Exercise attempted</p>
        </Col>
        <Col span={3}>
          <img src={ScoreIcon} />
          <p className="analytics-measure__value">
            40<span>/90</span>
          </p>
          <p className="analytics__measure">Content learnt</p>
        </Col> */}
      </Row>
    </div>
  );
};
export default AnalyticsCard;
